<template>
  <div>
    <h1 class="mb-6 font-bold text-3xl">
      <inertia-link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('jenjang_pendidikan.index')">
        Jenjang Pendidikan
      </inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message
      v-if="jenjangPendidikan.deleted_at"
      class="mb-6"
      @restore="restore">
      This jenjang_pendidikan has been deleted.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nama" />
          <text-area-input
            v-model="form.descriptions"
            :error="form.errors.descriptions"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Deskripsi" />
        </div>
        <div
          class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit">
            Update Jenjang Pendidikan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextAreaInput from '@/Shared/TextAreaInput'
import { useForm, Link } from '@inertiajs/vue2'

export default {
  metaInfo () {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    TextInput,
    TrashedMessage,
    TextAreaInput,
    'inertia-link': Link,
  },
  layout: Layout,
  props: {
    jenjangPendidikan: Object,
  },
  remember: 'form',
  data () {
    return {
      form: useForm({
        name: this.jenjangPendidikan.name,
        descriptions: this.jenjangPendidikan.descriptions,
        deleted_at: this.jenjangPendidikan.deleted_at,
      }),
    }
  },
  methods: {
    update () {
      this.form.put(
        this.route('jenjang_pendidikan.update', this.jenjangPendidikan.id),
      )
    },
    destroy () {
      if (confirm('Are you sure you want to delete this jenjang_pendidikan?')) {
        this.form.delete(
          this.route('jenjang_pendidikan.destroy', this.jenjangPendidikan.id),
        )
      }
    },
    restore () {
      if (
        confirm('Are you sure you want to restore this Jenjang Pendidikan?')
      ) {
        this.form.put(
          this.route('jenjang_pendidikan.restore', this.jenjangPendidikan.id),
        )
      }
    },
  },
}
</script>
